function parameterName(name, value) {
  return Array.isArray(value) && !name.endsWith("[]") ? `${name}[]` : name;
}

function appendParameter(searchParams, name, value) {
  if (value === null || value === undefined || value === "") {
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => appendParameter(searchParams, parameterName(name, value), item));
    return;
  }

  if (typeof value === "object") {
    Object.entries(value).forEach(([key, item]) => appendParameter(searchParams, `${name}[${key}]`, item));
    return;
  }

  searchParams.append(name, value);
}

export function finderParameterFamily(name) {
  return name.replace(/\[\]$/, "");
}

export function ownsFinderParameter(family, name) {
  const baseName = finderParameterFamily(family);
  return name === baseName || name.startsWith(`${baseName}[`);
}

function removeParameterFamily(searchParams, name) {
  [...searchParams.keys()].forEach((key) => {
    if (ownsFinderParameter(name, key)) {
      searchParams.delete(key);
    }
  });
}

/** Decodes Rails-style finder criteria while retaining repeated parameter names. */
export function decodeFinderParams(search) {
  const valuesByName = new Map();

  new URLSearchParams(search).forEach((value, name) => {
    valuesByName.set(name, [...(valuesByName.get(name) ?? []), value]);
  });

  return Object.fromEntries(
    [...valuesByName].map(([name, values]) => [name, name.endsWith("[]") || values.length > 1 ? values : values[0]]),
  );
}

/** Replaces finder-owned criteria without changing unrelated query parameters. */
export function replaceFinderParams(searchParams, params) {
  Object.entries(params).forEach(([name, value]) => {
    removeParameterFamily(searchParams, name);
    appendParameter(searchParams, name, value);
  });
}
